import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faIndianRupeeSign, faPiggyBank, faBuilding, faWeightScale, faPercentage, faHandHoldingMedical, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import '../css/financialcalculators.css';
import { Helmet } from 'react-helmet-async';

const FinancialCalculators = () => {
    const calculators = [
        {
            name: "EMI Calculator",
            path: "/emi-calculator",
            icon: faMoneyBillWave,
            description: "Calculate your monthly loan installments effortlessly.",
            category: "Investment & Planning"
        },
        {
            name: "RP Calculator",
            path: "/rp-calculator",
            icon: faIndianRupeeSign,
            description: "Plan your recurring deposits for future goals.",
            category: "Investment & Planning"
        },
        {
            name: "PPF Calculator",
            path: "/ppf-calculator",
            icon: faPiggyBank,
            description: "Project returns from your Public Provident Fund.",
            category: "Investment & Planning"
        },
        {
            name: "HRA Calculator",
            path: "/hra-calculator",
            icon: faBuilding,
            description: "Assess House Rent Allowance tax benefits clearly.",
            category: "Investment & Planning"
        },
        {
            name: "BMI Calculator",
            path: "/bmi-calculator",
            icon: faWeightScale,
            description: "Determine your Body Mass Index for health insights.",
            category: "Insurance & Health"
        },
        {
            name: "SI Calculator",
            path: "/si-calculator",
            icon: faPercentage,
            description: "Compute Simple Interest on your savings easily.",
            category: "Insurance & Health"
        },
        {
            name: "CI Calculator",
            path: "/ci-calculator",
            icon: faPercentage,
            description: "Calculate Compound Interest for exponential growth.",
            category: "Insurance & Health"
        },
        {
            name: "HLV Calculator",
            path: "/hlv-calculator",
            icon: faHandHoldingMedical,
            description: "Assess Human Life Value for adequate insurance cover.",
            category: "Insurance & Health"
        },
    ];

    const investmentCalculators = calculators.filter(calc => calc.category === "Investment & Planning");
    const insuranceCalculators = calculators.filter(calc => calc.category === "Insurance & Health");

    return (
        <div className="financial-calculators-section-stunning">
            <Helmet>
                <title>Financial Calculators | Plan Your Insurance & Investment India</title>
                <meta
                    name="description"
                    content="Use Policy Samjho's free financial calculators. Plan your insurance and investments with EMI, SIP, PPF, and HLV calculators for accurate financial planning in India."
                />
                <meta
                    name="keywords"
                    content="financial calculators, insurance calculator, investment calculator, emi calculator, hlv calculator, ppf calculator, insurance planning India, financial planning tools"
                />
                <link rel="canonical" href="https://policysamjho.com/calculators/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "SoftwareApplication",
                        "name": "Financial Calculators - Policy Samjho",
                        "description": "Accurate insurance and investment calculators including EMI, RP, BMI, PPF, HRA, CI, SI, and HLV to help plan your finances and insurance coverage.",
                        "applicationCategory": "FinanceApplication",
                        "operatingSystem": "All",
                        "url": "https://policysamjho.com/calculators/",
                        "author": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "offers": {
                            "@type": "Offer",
                            "price": "0",
                            "priceCurrency": "INR"
                        }
                    })}
                </script>
            </Helmet>

            <div className="stunning-header">
                <p className="stunning-subheading">EXPERT FINANCIAL PLANNING TOOLS</p>
                <h1 className="stunning-main-heading">Financial Calculators for Insurance & Investment</h1>
            </div>

            <div className="stunning-calculator-content-wrapper">
                <div className="stunning-category-block stunning-block-left">
                    <h2 className="stunning-category-title">Investment Calculators</h2>
                    <p className="stunning-category-description">
                        Plan your investments, calculate accurate returns, and manage your savings effectively with our expert tools.
                    </p>
                    <div className="stunning-calculators-grid">
                        {investmentCalculators.map((calc, index) => (
                            <Link to={calc.path} key={index} className="stunning-calculator-card">
                                <div className="stunning-card-icon-area">
                                    <FontAwesomeIcon icon={calc.icon} className="stunning-card-icon" />
                                </div>
                                <div className="stunning-card-text">
                                    <h3 className="stunning-card-title">{calc.name}</h3>
                                    <p className="stunning-card-description">{calc.description}</p>
                                    <span className="stunning-card-link">
                                        Calculate Now <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

                <div className="stunning-category-block stunning-block-right">
                    <h2 className="stunning-category-title">Insurance Calculators</h2>
                    <p className="stunning-category-description">
                        Understand your insurance needs and determine the right coverage with our Human Life Value and Health tools.
                    </p>
                    <div className="stunning-calculators-grid">
                        {insuranceCalculators.map((calc, index) => (
                            <Link to={calc.path} key={index} className="stunning-calculator-card">
                                <div className="stunning-card-icon-area">
                                    <FontAwesomeIcon icon={calc.icon} className="stunning-card-icon" />
                                </div>
                                <div className="stunning-card-text">
                                    <h3 className="stunning-card-title">{calc.name}</h3>
                                    <p className="stunning-card-description">{calc.description}</p>
                                    <span className="stunning-card-link">
                                        Calculate Now <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default FinancialCalculators;